<template>
	<div>
		<common-header navbar-index=4></common-header>
		<cpp-banner></cpp-banner>
		<dotest-content :doTestList="doTestList" :fid="fid" :fout="fout" :paperList="paperList"></dotest-content>
		<common-footer></common-footer>
	</div>
</template>

<script>
	import CommonHeader from '@/pages/common/Header'
	import CppBanner from '@/pages/cpp/components/CppBanner'
	import DotestContent from '@/pages/cpp/components/DotestContent'
	import CommonFooter from '@/pages/common/Footer'
	import axios from 'axios'
	export default {
		name: 'DoTest',
		components: {
			CommonHeader,
			CppBanner,
			DotestContent,
			CommonFooter
		},
		data() {
			return {
				doTestList: [],
				fid: null,
				fout: null,
				paperList: []
			}
		},
		methods: {
			getDataInfo(tid) {
				axios.get('/itmswcn/learn/cpp/test/' + tid).then(this.getDataInfoSucc)
				axios.get('/itmswcn/learn/cpp/paper/query/' + tid).then(this.getDataInfo2Succ)
			},
			getDataInfoSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
					this.doTestList = data
					this.fid = data.fid
					this.fout = data.list[0].demoOut
				}
			},
			getDataInfo2Succ(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
					this.paperList = data
				}
			}
		},
		mounted() {
			this.getDataInfo(this.$route.query.tid)
		}
	};
</script>

<style lang="scss" scoped>

</style>